import { useCreateDataTableOptions } from "@/components/data-table/hooks/useCreateDataTableOptions";
import { QueryTable } from "@/components/query-table/QueryTable";
import { StandardInMemoryTable } from "@/components/in-memory-table/StandardInMemoryTable";
import { useContractorsPlannedHoursWizardColumnOverrides } from "@/modules/contractorsPlannedHoursWizard/hooks/useContractorsPlannedHoursWizardColumnOverrides";
import { displayContractorsPlannedHoursWizardAllocation } from "@/schemas/contractorsPlannedHoursWizard";
import { DisplayContractorsPlannedHoursWizardAllocation } from "@/types/contractorsPlannedHoursWizard";
import { Check } from "lucide-react";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export function ContractorsPlannedHoursWizardSelectedForCalculateList({
  snapshotAllocations,
}: {
  snapshotAllocations: DisplayContractorsPlannedHoursWizardAllocation[];
}) {
  const { t } = useTranslation();
  const columnOverrides = useContractorsPlannedHoursWizardColumnOverrides();
  const tableFeatures = useMemo(
    () => ({
      enableRowSelection: false,
      enableFilters: false,
      enableSorting: false,
    }),
    [],
  );

  const options =
    useCreateDataTableOptions<DisplayContractorsPlannedHoursWizardAllocation>(
      "contractorsPlannedHoursWizardResultsSnapshot",
    );
  const selectedRowCount = snapshotAllocations.length;

  return (
    <StandardInMemoryTable<DisplayContractorsPlannedHoursWizardAllocation>
      schema={displayContractorsPlannedHoursWizardAllocation}
      name="contractorsPlannedHoursWizardResultsSnapshot"
      translationKey="contractorsPlannedHoursWizard"
      items={snapshotAllocations}
      options={options}
      tableFeatures={tableFeatures}
      columnOverrides={columnOverrides}
    >
      <div className="flex min-h-0 flex-1 flex-col gap-1">
        <div className="flex flex-row items-center gap-2 py-1">
          <QueryTable.Menubar className="mb-0 min-w-0 w-full flex-1 justify-start">
            <QueryTable.Menubar.Columns />
            <QueryTable.Menubar.Reset />
          </QueryTable.Menubar>
        </div>
        <div className="mb-1 flex min-h-32 flex-1 flex-col gap-1">
          <StandardInMemoryTable.Content className="min-h-0 flex-1 flex-col">
            <div className="flex min-h-[calc(3.5rem+2px)] flex-wrap items-center gap-4 py-3 px-2 text-sm text-slate-600">
              <span className="flex shrink-0 items-center gap-2">
                <Check className="h-4 w-4" />
                <span>
                  {t("contractorsPlannedHoursWizard.results.snapshotRowCount", {
                    count: selectedRowCount,
                  })}
                </span>
              </span>
            </div>
          </StandardInMemoryTable.Content>
        </div>
      </div>
    </StandardInMemoryTable>
  );
}
